import { Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-left-banner',
    templateUrl: './left-banner.component.html',
    styleUrls: ['./left-banner.component.scss'],
    standalone: false
})
export class LeftBannerComponent {
  constructor(public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig,) {

  }
  leftBannerNode: Observable<any> = this.bannerComponent.data$; 
  getImage(image: any): string {
    if (image?.url) {
      return this.config.backend?.occ?.baseUrl + image.url;
    }
    if (image?.desktop?.url) {
      return this.config.backend?.occ?.baseUrl + image.desktop.url;
    }
    return '';
  }
}
